// @flow
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Link, Route, Redirect } from 'react-router-dom';

import theme from './assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';

import { Row, Col, Grid } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import './App.css';
import './assets/react-toolbox/theme.css';

import { LogoImg } from './brand-configs';
import ProgressBar from 'react-toolbox/lib/progress_bar';

// ##### Comps
import LoginComp from './login/LoginComp';
import WizardComp from './wizard/WizardComp';
import ProjectsComp from './projects/ProjectsComp';
import BillingComp from './billing/BillingComp';
import AdminComp from './admin/AdminComp';
import ProfileComp from './profile/ProfileComp';
import StatsComp from './admin/StatsComp';

// ##### Actions
import UserActions from './actions/user.actions';
import AppActions from './actions/app.actions';

class App extends Component {
  componentDidMount() {
    this.props.userActions.fetchMe();
    this.props.appActions.getEnv();
  }
  render() {
    const { user, unknown, location, translate } = this.props;

    const showAdminLink = user && user.isAdmin;

    const adminLink = <Link to="/admin">{'Admin'}</Link>;
    const statsLink = <Link to="/stats">{'Stats'}</Link>;
    const profileLink = <Link to="/profile">{translate('app.profileLink')}</Link>;
    const projectsLink = <Link to="/projects">{translate('app.projectsLink')}</Link>;
    const showProfileLink = location.pathname !== '/profile' && user && user.isWizardDone;
    const showProjectsLink = location.pathname !== '/projects' && user && user.isWizardDone;

    const userTag = (
      <div className="user-tag">
        {showAdminLink && adminLink} {showAdminLink && ' ● '}
        {showAdminLink && statsLink} {showAdminLink && ' ● '}
        {showProjectsLink && projectsLink} {showProjectsLink && ' ● '}
        {showProfileLink && profileLink} {showProfileLink && ' ● '}
        <a href="/auth/logout">{translate('app.logoutLink')}</a>
      </div>
    );

    const unknownSession = (
      <ThemeProvider theme={theme}>
        <div className="App">
          <div className="App-bkg" />
          <Grid fluid={true} className="App-inner">
            <div className="row full-height center-xs middle-xs">
              <div className="content col-xs-10 col-sm-6 col-md-4 loading">
                <h2>{translate('app.Loading')}</h2>
                <ProgressBar
                  type="circular"
                  mode="indeterminate"
                  multicolor={true}
                  className="App-loader"
                />
              </div>
            </div>
          </Grid>
        </div>
      </ThemeProvider>
    );
    const globalCss = ['App', process.env.REACT_APP_BRAND || ''].join(' ');

    const knownSession = (
      <ThemeProvider theme={theme}>
        <div className={globalCss}>
          <div className="App-bkg" />
          <Grid fluid={true} className="App-inner">
            <Row>
              <Col xs={12}>
                <Row center="xs">
                  <Col xs={10}>
                    <header className="App-header">
                      <Row start="xs">
                        <Col xs={4}>
                          <img src={LogoImg} alt="Log Hero" className="App-logo" />
                        </Col>
                        <Col xs={8}>
                          <Row end="xs">
                            <Col xs={10}>{user && !unknown ? userTag : null}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </header>
                    <main>
                      <Route exact={true} path="/" render={() => <Redirect to="/projects" />} />
                      <Route path="/billing" component={BillingComp} />
                      <Route exact={true} path="/login" component={LoginComp} />
                      <Route exact={true} path="/projects" component={ProjectsComp} />
                      <Route path="/wizard" component={WizardComp} />
                      <Route path="/admin" component={AdminComp} />
                      <Route path="/profile" component={ProfileComp} />
                      <Route path="/stats" component={StatsComp} />
                    </main>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Grid>
        </div>
      </ThemeProvider>
    );
    return unknown ? unknownSession : knownSession;
  }
}

function mapStateToProps(state) {
  const search = state.routing.location.search;
  return {
    translate: getTranslate(state.locale),
    location: state.routing.location,
    user: state.me.user,
    unknown: state.me.unknown
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(UserActions, dispatch),
    appActions: bindActionCreators(AppActions, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js